module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-LightItalic-WebS.9da78535.woff2";